export default __webpack_public_path__ + "static/media/tenha-o-publico-certo-na-sua-mao.02cc6d31.png";